/* eslint-disable @typescript-eslint/restrict-plus-operands */
import { DurationInput } from '@dreryk/react-calendar';

import { AppointmentSchedule } from '~libs.shared.appointments-timetable';

const DEFAULT_MIN_HOUR = 0;
const DEFAULT_MAX_HOUR = 23;
const DEFAULT_MIN_TIME = {
   hours: DEFAULT_MIN_HOUR,
   minutes: 0,
};
const DEFAULT_MAX_TIME = {
   hours: DEFAULT_MAX_HOUR,
   minutes: 59,
};

type MinMaxTime = {
   minTime: DurationInput;
   maxTime: DurationInput;
};

export const getMinMaxTime = (
   appointmentSchedules: AppointmentSchedule[] | null,
   preferScheduleOnlyVisible: boolean,
   preferCancelledVisitsVisible: boolean
): MinMaxTime => {
   if (!appointmentSchedules?.length || !preferScheduleOnlyVisible) {
      return {
         minTime: DEFAULT_MIN_TIME,
         maxTime: DEFAULT_MAX_TIME,
      };
   }

   const beginDates = appointmentSchedules.flatMap((schedule) => [
      ...schedule.eventsSlots
         .filter((slot) => preferCancelledVisitsVisible || slot.status !== 'CANCELLED')
         .map((slot) => slot.timeSlot.getBeginDate()),
      ...(schedule.backgroundSlots?.map((slot) => slot.getBeginDate()) ?? []),
   ]);

   const endDates = appointmentSchedules.flatMap((schedule) => [
      ...schedule.eventsSlots
         .filter((slot) => preferCancelledVisitsVisible || slot.status !== 'CANCELLED')
         .map((slot) => slot.timeSlot.getEndDate()),
      ...(schedule.backgroundSlots?.map((slot) => slot.getEndDate()) ?? []),
   ]);

   const noHours = !beginDates.length && !endDates.length;

   if (noHours) {
      return {
         minTime: DEFAULT_MIN_TIME,
         maxTime: DEFAULT_MAX_TIME,
      };
   }

   const minHour = beginDates.length ? Math.min(...beginDates.map((d) => d.getHours())) : DEFAULT_MIN_HOUR;

   const maxHour = endDates.length
      ? Math.max(...endDates.map((d) => (d.getMinutes() > 0 ? d.getHours() + 1 : d.getHours())))
      : DEFAULT_MAX_HOUR;

   return {
      minTime: { hours: minHour },
      maxTime: { hours: maxHour },
   };
};
